import config from './config';
import { async_utils } from './frfr-async-utils';
import { frfr_res_utils } from './frfr-res-utils';
import fdb from './frfr-frontend-db';
import { selectAuthSessions, selectUserList, selectUserSingle, selectComorditemList_OLD, selectVirbomSingle_OLD, selectGenusPpList, selectComorderList, selectComorditemList_2023, selectVirbomSingleByParentId } from './fdb-selectors';
import { mutatorZaInicijalniSeed, mutatorAuthSessionsCreate, mutatorAuthSessionsDeleteByToken, mutatorAuthSessionsDeleteByUserId, mutatorUserCreate, mutatorUserUpdate, mutatorComorditemCreate, comboDraftUpdate, comboGenusUpdateSmart, mutatorComorderCreate, mutatorComorderUpdate, comboComorditemCreate_OLD, mutatorComorditemUpdate, mutatorComorderFlagDeleted, mutatorComorditemFlagDeleted, comboComorditemCreate_2023, comboDraftUpdateWithRevisions_2023, comboComorditemUpdate } from './fdb-mutators';
import { virtel_schema_smart_get } from '../ter/ter-virtel-definition-lib';
import { date_utils } from './frfr-date-utils';
import { _zz_placeholder_res_payload_lib_document_example1, _zz_placeholder_res_payload_lib_s4_temp1 } from './zz/zz-placeholders';


/*
DOKUMENTACIJA: 
- Postoji ukupno 6 parametara koji čine jedan request sa simBackend-om:
simEndpoint,
simMethod,
simHeaders,
simBody,
simQueryParams,
simRouteParams
- u ovom fajlu prefix "get" znaci HTTP GET metod komunikacije sa serverom, a prefix "post" HTTP POST metod...
- svaka od simBackend funkcija prima samo pet argumenata 
(simMethod, simHeaders, simBody, simQueryParams, simRouteParams): 
prvi je simMethod,
drugi je simHeaders,
treci je simBody
cetvrti je simQueryParams
peti je simRouteParams
- simHeaders je argument i to je object koji simulira http request headers (podatke nevidljive za obicne korisnike)  
- simBody argument moze biti ignorisan i on simulira http request message body.
- simBody argument treba uvek da bude OBJEKAT radi konzistentnosti i radi lakseg odrzavanja kompatibilnosti izmedju ajax-adpter, simbackend i pravog backenda.
- simQueryParams je argument, takodje moze biti ignorisan, i on sluzi da nosi objekat sa URL query parametrima.
simWueryParams treba uvek da bude OBJEKAT radi konzistentnosti i radi lakseg odrzavanja kompatibilnosti izmedju ajax-adpter, simbackend i pravog backenda.
- simRouteParams argument, takodje moze biti ignorisan, i on sluzi da nosi objekat sa vrednostima koje simuliraju Node express Route parameters ( https://expressjs.com/en/guide/routing.html
Route parameters are named URL segments that are used to capture the values specified at their position in the URL path. The captured values are populated in the req.params objec )

- Kako da se barata sa URL query parametrima?
Problem sa url query parametrima je sto se oni uvek primaju kao string iako su cesto u pitanju ID-ovi koji na backendu reprezentuju integer brojeve. Zbog toga, kod svih POST zahteve treba izbegavati URL query parametre i slati ih unutar POST BODY.
A za GET zahteve koristiti simQueryParams koji mora pazljivo da se tretira na backendu.

*/


// keys for local storage simulated backend database
const server_thisis = 'Simulirani backend na frontendu';
const FDB_KEY = config.FDB_KEY; //
let dont_store = true;
if (config.fdb_store_into_filesystem === true) {
  dont_store = false;
}
const mydb = fdb(FDB_KEY, dont_store); // uspostljamo konkeciju (odnosno pravimo fdb "instancu") sa bazom pod nazivom iz konstante FDB_KEY

let delay = config.ajaxSimulatorDelay;

const _extractTokenFromSimHeaders = (simHeaders) => {
  const token_header_key = config.TOKEN_HEADER_KEY;
  // let token = simHeaders.token;
  let token = simHeaders[token_header_key];
  return token;
};

const _tokenCreator = (username) => {
  let token = 'token' + username + Date.now() + 'sesija';
  return token;
};

const _authDataByToken = async (token) => {
  let podudarnost = false;
  let userId = null;
  let user = false;
  // KORAK provera tokena u sesijama
  let sesije = [];
  const dbres = await mydb.get(selectAuthSessions);
  // console.log(sesije)
  if (Array.isArray(dbres)) {
    sesije = dbres;
  }
  sesije.forEach((ses) => {
    // console.log(ses)
    if (ses.token === token) {
      // JESTE ULOGOVAN. TOKEN POSTOJI
      userId = ses.user_id;
      podudarnost = true;
    }
  });
  // KORAK uzimanje podatak o korisniku na osnovu user_id iz sesije
  // console.log(userId);
  if (podudarnost) {
    const dbres2user = await mydb.get(selectUserSingle, userId);
    if (dbres2user && dbres2user.activated === true) {
      const user = dbres2user;
      // console.log(user);
      return user;
    }
  }
  return false;
};

const _responsePristupOdbijen = () => {
  const response = frfr_res_utils.erf_pack_response({
    success: false,
    error: true,
    meta: {
      readme: 'Response od API... pristup odbijen'
    },
    payload: 'PRISTUP ODBIJEN'
  });
  return response
};


export const simBackend = {};


// AUTH API-ji

simBackend.postAuthLogout = async (simMethod, simHeaders, { user_id }) => {
  let sesije = [];
  const dbres = await mydb.get(selectAuthSessions);
  if (Array.isArray(dbres)) {
    sesije = dbres;
  }
  const token = _extractTokenFromSimHeaders(simHeaders);
  // console.log(id);
  // console.log(token);
  // console.log(sesije);
  /*
  let noveSesije = sesije.filter((ses) => {
    // console.log(ses);
    if (ses.user_id !== id) {
      return true; // nema izmene
    } else {
      return false; // brisanje sesije
    }
  });
  */
  /*
  let sesijaZaBrisanjeId = null;
  sesije.forEach((ses) => {
    if (ses.user_id === id) {
      sesijaZaBrisanjeId = ses.id;
    }
  });
  let dbres = false;
  dbres = await mydb.mutate(mutatorAuthSesijaDelete, sesijaZaBrisanjeId);
  */
  const dbres1logout = await mydb.mutate(mutatorAuthSessionsDeleteByToken, token);
  // KORAK DODATNI 
  // uobicajeno se na backendu logout vrsi samo brisanjem prema tokenu, kako bi korisnik i dalje mogao da ostane ulogovan na drugim kompjuterima. Ali za ovu aplikaciju dodatno ipak vrsimo logut na svi msesijama za taj user_id.
  const dbres2logout2 = await mydb.mutate(mutatorAuthSessionsDeleteByUserId, user_id);
  // KORAK pauza za response servera
  await async_utils.pause(delay); // pravimo pauzu
  // RES
  let response = false;
  // RES SUCCESS
  if (true) {
    response = frfr_res_utils.srf_pack_response({
      success: true,
      payload: false,
      meta: {
        readme: 'ovo je odgovor od logout APIja - Izlogovani ste na backend strani',
      }
    });
  }
  return response;
}

// FORM LOGIN (logovanje preko login forme)
simBackend.postAuthFormLogin = async (simMethod, simHeaders, { entbox }) => {
  let username = entbox.username;
  let password = entbox.password;
  // let ulogovan = false;
  // KORAK provere podudarnosti username i passworda
  let korisnici = [];
  const dbres = await mydb.get(selectUserList);
  if (Array.isArray(dbres)) {
    korisnici = dbres;
  }
  let userId = null;
  let podudarnost = false;
  let user = false;
  korisnici.forEach((korisnik) => {
    if (korisnik.username === username && korisnik.password === password) {
      podudarnost = true;
      userId = korisnik.id;
      user = korisnik;
    }
  });
  let token = 'NOTOKEN';
  if (podudarnost && user.activated === true) {
    // KORAK ukoliko smo pronasli podudarnost upisujemo sesiju u bazu
    token = _tokenCreator(username); // kreiramo novi token
    // DOKUMENTACIJA: sesije su podaci o ulogovanim korisnicima, njihovi tokeni i id-ovi
    let sesija = {
      id: 'PLACEHOLDER',
      user_id: userId,
      username: username,
      token: token
    };
    await mydb.mutate(mutatorAuthSessionsCreate, sesija);
  }
  // KORAK pauza za response servera
  await async_utils.pause(delay); // pravimo pauzu
  // RES
  let response;
  let error = false;
  let status = null;
  let error_type = '';
  if (podudarnost) {
    if (user.activated === true) {
      // RES SUCCESS
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo form login'
        },
        payload: {
          ulogovan: true,
          token: token
        }
      });
    } else {
      // RES FAIL USER NOT ACTIVATED
      error = true;
      status = 401;
      error_type = 'Korisnik nije aktiviran';
    }
  } else {
    // RES FAIL WRONG USERNAME OR PASSWORD
    error = true;
    status = 401;
    error_type = 'Nepoznato korisničko ime ili password';
  }
  //
  if (error === true) {
    response = frfr_res_utils.erf_pack_response({
      error_type: error_type
    });
  }
  //
  return response;
};


// AUTOLOGIN (provera da li si ulogovan odmah pri startu aplikacije)
simBackend.getAuthMyUserData = async (simMethod, simHeaders) => {
  // NOVO
  // KORAK preuzimamo podatke o korisniku na osnovu tokena
  let user = false;
  const token = _extractTokenFromSimHeaders(simHeaders);
  // console.log(token);
  const server_info = {
    thisis: server_thisis
  };
  user = await _authDataByToken(token);
  // KORAK pauza za response servera
  await async_utils.pause(delay); // pravimo pauzu
  // RES
  let response;
  // console.log(user);
  if (user && user.username) {
    // RES SUCCESS
    delete user.password; // uklanjamo password properti jer ne sme biti vidljiv nigde van backenda
    response = frfr_res_utils.srf_pack_response({
      success: true,
      meta: {
        readme: 'Response od API... uspeo AUTOLOGIN tj. my user data'
      },
      payload: {
        user,
        server_info
      }
    });
  } else {
    // RES FAIL
    response = frfr_res_utils.srf_pack_response({
      success: false,
      meta: {
        readme: 'Response od API... nije uspeo AUTOLOGIN tj. my user data'
      },
      payload: false
    });
  }
  return response;
};


// API-ji koji nisu za auth

simBackend.getDevDbWhole = async (simMethod, simHeaders) => {
  // get complete database object
  const dbres = await mydb.get(null);
  // RES
  let response;
  if (true) {
    response = frfr_res_utils.srf_pack_response({
      success: true,
      meta: {
        readme: 'Response od API getDevDbWhole...'
      },
      payload: dbres
    });
    return response;
  }
};


simBackend.postAdminDbInitialSeed = async (simMethod, simHeaders) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  // dozvoli ili odbij pristup
  let response = false;
  if (true) {
    // TODO: inicjalni seed mora da bude poseban utility alat. Posto ne postoje token ni logovanej kad baza ne postoji
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    await mydb.info();
    await mydb.mutate(mutatorZaInicijalniSeed);
    // RES SUCCESS
    if (true) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API...'
        },
        payload: 'Upisali smo inicijalne podatke u bazu :)'
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.postAdminDbDelete = async (simMethod, simHeaders) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ADMIN' || user.role === 'DEV')) {
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    await mydb.info();
    await mydb.delete_database(); // delete entire database from local storage
    // RES SUCCESS
    if (true) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API...'
        },
        payload: 'Obrisali smo bazu! '
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};



simBackend.getUserList = async (simMethod, simHeaders) => {
  let response = false;
  let arr = [];
  // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
  const dbres = await mydb.get(selectUserList);
  // console.log(arr);
  await async_utils.pause(delay); // pravimo pauzu

  // RES
  if (Array.isArray(dbres)) {
    arr = dbres;
    response = frfr_res_utils.srf_pack_response({
      success: true,
      meta: {
        readme: 'Response od API...'
      },
      payload: arr
    });
    return response;
  } else {
    return response;
  }
};


simBackend.postUserCreate = async (simMethod, simHeaders, { entbox }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ADMIN' || user.role === 'DEV')) {
    let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    dbres = await mydb.mutate(mutatorUserCreate, entbox);
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (dbres) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo create usera'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.postUserUpdate = async (simMethod, simHeaders, { entbox, id }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ADMIN' || user.role === 'DEV')) {
    let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    dbres = await mydb.mutate(mutatorUserUpdate, { entbox, id });
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (dbres) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo update usera',
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.getComorderList = async (simMethod, simHeaders) => {
  let response = false;
  let arr = [];
  // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
  const dbres = await mydb.get(selectComorderList);
  // console.log(arr);
  await async_utils.pause(delay); // pravimo pauzu
  // RES
  if (Array.isArray(dbres)) {
    arr = dbres;
    response = frfr_res_utils.srf_pack_response({
      success: true,
      meta: {
        readme: 'Response od API...'
      },
      payload: arr
    });
    return response;
  } else {
    return response;
  }
};


simBackend.postComorderCreate = async (simMethod, simHeaders, { entbox }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  const userId = user.id;
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    dbres = await mydb.mutate(mutatorComorderCreate, {
      ...entbox,
      user_created: userId,
      datetime_created: date_utils.now_frfrdatetimestring()
    });
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (dbres) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo create comorder'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.postComorderUpdate = async (simMethod, simHeaders, { entbox, id }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  const userId = user.id;
  console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    dbres = await mydb.mutate(mutatorComorderUpdate, {
      entbox: {
        ...entbox,
        user_modified: userId,
        datetime_modified: date_utils.now_frfrdatetimestring()
      },
      id
    });
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (dbres) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo update comorder'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.postComorderUpdateFlagDeleted = async (simMethod, simHeaders, { id }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  const userId = user.id;
  console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    dbres = await mydb.mutate(mutatorComorderFlagDeleted, {
      id,
      flag_deleted: true,
      user_deleted: userId,
      datetime_deleted: date_utils.now_frfrdatetimestring()
    });
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (dbres) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo FLAG DELETE comorder'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.getComorditemList = async (simMethod, simHeaders) => {
  let response = false;
  let arr = [];
  // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
  // arr = await mydb.get(selectComorditemList_OLD);
  const dbres = await mydb.get(selectComorditemList_2023); // NOVO 2023
  // console.log(arr);
  await async_utils.pause(delay); // pravimo pauzu
  // RES
  if (Array.isArray(arr)) {
    arr = dbres;
    response = frfr_res_utils.srf_pack_response({
      success: true,
      meta: {
        readme: 'Response od API...'
      },
      payload: arr
    });
    return response;
  } else {
    return response;
  }
};


simBackend.postComorditemCreate = async (simMethod, simHeaders, { entbox }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  const userId = user.id;
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    // let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    // dbres = await mydb.mutate(mutatorComorditemCreate, entbox);
    // const [success, dbres] = await mydb.mutate_and_get(comboComorditemCreate_OLD, {
    const [success, dbres] = await mydb.mutate_and_get(comboComorditemCreate_2023, { // NOVO 2023
      ...entbox,
      user_created: userId,
      datetime_created: date_utils.now_frfrdatetimestring()
    });
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    // if (dbres) {
    if (success) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo create comorder'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.postComorditemUpdate = async (simMethod, simHeaders, { entbox, id }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  const userId = user.id;
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    /*
    let dbres = false;
    dbres = await mydb.mutate(mutatorComorditemUpdate, {
      entbox: {
        ...entbox,
        user_modified: userId,
        datetime_modified: date_utils.now_frfrdatetimestring()
      },
      id
    });
    */
    const [success, dbres] = await mydb.mutate_and_get(comboComorditemUpdate, {
      entbox: {
        ...entbox,
        user_modified: userId,
        datetime_modified: date_utils.now_frfrdatetimestring()
      },
      id
    });
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (success) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo update comorditem'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};

simBackend.postComorditemUpdateFlagDeleted = async (simMethod, simHeaders, { id }) => {
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  const userId = user.id;
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    dbres = await mydb.mutate(mutatorComorditemFlagDeleted, {
      id,
      flag_deleted: true,
      user_deleted: userId,
      datetime_deleted: date_utils.now_frfrdatetimestring()
    });
    // console.log(dbres);
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (dbres) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo FLAG DELETE comorditem'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.getVirbomSingleByParentId = async (simMethod, simHeaders, simBody, simQueryParams) => {
  let response = false;
  const { virbom_parent_id } = simQueryParams;
  // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
  // let virbom = await mydb.get(selectVirbomSingle_OLD, virbom_parent_id);
  const dbres = await mydb.get(selectVirbomSingleByParentId, virbom_parent_id); // NOVO 2023
  let virbom = dbres; // virbom virbom
  const virbom_resbox = {
    thisis: 'virbom_resbox',
    virbom_resbox_error: true,
    virbom_is_blank: true,
    virbom_parent_id: virbom_parent_id,
    // of_id: _rev_id,
    readme: 'CASE simuliramo prazan virbom',
  }; // TODO
  // console.log(virbom);
  // console.log(virbom);
  await async_utils.pause(delay); // pravimo pauzu
  // RES
  // TODO mora da se ubaci za NEUSPEH response JAKO VAZNO!!
  response = frfr_res_utils.srf_pack_response({
    success: true,
    meta: {
      readme: 'Response od API... uspelo citanje projekta iz baze'
    },
    payload: {
      resbox: virbom_resbox
    }
  });
  // console.log(response);
  return response;
};


simBackend.postVirbomUpdate = async (simMethod, simHeaders, { xentbox }) => {
  // 
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  const userId = user.id;
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    // let dbres = false;
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    console.log(xentbox);
    // const [success, dbres] = await mydb.mutate_and_get(comboDraftUpdate, xentbox);
    const [success, dbres] = await mydb.mutate_and_get(
      comboDraftUpdateWithRevisions_2023,
      {
        ...xentbox,
        user_modified: userId,
        datetime_modified: date_utils.now_frfrdatetimestring()
      });
    console.log(success);
    console.log(dbres); // dbres od comboDraftUpdate su kompletne instance onako kako su zapisane u bazu
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (success) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo update drafta u bazu'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


simBackend.getGenusPpList = async (simMethod, simHeaders) => {
  // NOVA 2021mart
  let response = false;
  let arr = [];
  // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
  const dbres = await mydb.get(selectGenusPpList);
  // console.log(arr);
  await async_utils.pause(delay); // pravimo pauzu
  // RES
  if (Array.isArray(dbres)) {
    arr = dbres;
    response = frfr_res_utils.srf_pack_response({
      success: true,
      meta: {
        readme: 'Response od API...'
      },
      payload: arr
    });
    return response;
  } else {
    return response;
  }
};


// NOVO 2021mart za virtel resenje...
simBackend.postGenusUpdateSmartArr = async (simMethod, simHeaders, { virtel_need_genus_arr }) => {
  // CILJ: mora da vrati JEDAN ident, a prethodno kreira novi genus ukoliko takav vec ne postoji

  // TODO....... radimo....
  // KORAK obavezna autentifikacija za ovaj API
  const token = _extractTokenFromSimHeaders(simHeaders);
  let user = await _authDataByToken(token);
  // console.log(user);
  // dozvoli ili odbij pristup
  let response = false;
  if (user && (user.role === 'ING' || user.role === 'ADMIN' || user.role === 'DEV')) {
    // KORAK backend je primio zahtev i sada radi sa bazom da dobije/pripremi podatke
    let all_success = true;
    let virtel_subkey_plus_genus_ident_arr = []; // NOVO DECEMBAR
    let _arr = [...virtel_need_genus_arr];
    console.log(_arr);
    console.log('number of iterations needed: ' + _arr.length);

    if (config.backend_ganus_enabled === true) {
      await mydb.advanced_boost_enabled(); // NOVO BOOST
      let _afcounter = 0;
      for (const virtel of _arr) {
        _afcounter++;
        console.log('async for loop iteration: ' + _afcounter);
        console.log(virtel);
        const sema = virtel_schema_smart_get(virtel.virtelschemakey);
        if (sema && sema.program && sema.program.use_genus === true) {
          const [success, dbres] = await mydb.mutate_and_get(comboGenusUpdateSmart, virtel); // update genus smart and get ident
          if (success === true) {
            const genus_ident = dbres;
            const virtel_id_plus_genus_ident = {
              subkey: virtel.subkey,
              genus_ident: genus_ident
            };
            virtel_subkey_plus_genus_ident_arr.push(virtel_id_plus_genus_ident); // pushuje virtel id sa pravim GENUS_IDENT
          } else {
            all_success = false;
          }
        } else {
          console.log('- NOT sena or not use_genus');
          console.log(virtel.virtelschemakey);
        }

      };
      await mydb.advanced_boost_disabled(); // NOVO BOOST DISABLED
      console.log('total number of async for loop iterations: ' + _afcounter);
    } else {
      // if backend_ganus_enabled === false
      all_success = true;
    }

    /*
    const async_func = async (virtel)=> {
      console.log('asyncForEach iteration');
      console.log(virtel);
      const [success, dbres] = await mydb.mutate_and_get(comboGenusUpdateSmart, virtel);
      if (success === false) {
        all_success = false;
        const ident = dbres;
        const virtel_id_plus_genus_ident = {
          subkey: virtel.subkey,
          genus_ident: genus_ident
        };
        virtel_subkey_plus_genus_ident_arr.push(virtel_id_plus_genus_ident); // pushuje virtel id sa pravim GENUS_IDENT
      }
    }
    await async_utils.asyncForEach(_arr, async_func);
    */

    /*
    virtel_need_genus_arr.forEach((virtel) => {
      // PROBLEM: kako da ide sa foreach asinhrono ???
      // ne moze ni da se izbaci async jer ce returnovana vrednost biti Promise sa statusom pending
      // const [success, dbres] = await mydb.mutate_and_get(comboGenusUpdateSmart, virtel);
      const [success, dbres] = mydb.mutate_and_get(comboGenusUpdateSmart, virtel);
      if (success === false) {
        all_success = false;
        const ident = dbres;
        const virtel_id_plus_genus_ident = {
          subkey: virtel.subkey,
          genus_ident: genus_ident
        };
        virtel_subkey_plus_genus_ident_arr.push(virtel_id_plus_genus_ident); // pushuje virtel id sa pravim GENUS_IDENT
      }
    });
    */
    const dbres = virtel_subkey_plus_genus_ident_arr; // NOVO DECEMBAR
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    if (all_success) {
      response = frfr_res_utils.srf_pack_response({
        success: true,
        meta: {
          readme: 'Response od API... uspeo update genusa u bazu'
        },
        payload: dbres
      });
    }
  } else {
    response = _responsePristupOdbijen(); // RES ACCESS DENIED
  }
  return response;
};


// ---------- PLACEHOLDERS


simBackend.placholders = {};


simBackend.placholders._return_empty_array = () => {
  const res_payload = [];
  const response = frfr_res_utils.srf_pack_response({
    success: true,
    meta: {
      readme: 'Response od SIM BACKEND .placeholders._return_empty_array'
    },
    payload: res_payload
  });
  return response;
};


simBackend.placholders._return_empty_object = () => {
  const res_payload = {};
  const response = frfr_res_utils.srf_pack_response({
    success: true,
    meta: {
      readme: 'Response od SIM BACKEND .placeholders._return_empty_object'
    },
    payload: res_payload
  });
  return response;
};


simBackend.placholders._return_lib_document_example_ventilatori1 = () => {
  const res_payload = [
    ..._zz_placeholder_res_payload_lib_document_example1
  ];
  const response = frfr_res_utils.srf_pack_response({
    success: true,
    meta: {
      readme: 'Response od SIM BACKEND .placeholders._return_lib_document_example_ventilatori1'
    },
    payload: res_payload
  });
  return response;
};


simBackend.placholders._return_lib_document_example_s4_templates1 = () => {
  const res_payload = [
    ..._zz_placeholder_res_payload_lib_s4_temp1
  ];
  const response = frfr_res_utils.srf_pack_response({
    success: true,
    meta: {
      readme: 'Response od SIM BACKEND .placeholders._return_lib_document_example_s4_templates1'
    },
    payload: res_payload
  });
  return response;
};


// export default simBackend;
// module.exports = simBackend; // Node.js export default
